import request from "@/utils/request";
import { ElMessage } from "element-plus";

export default {
  name: "ApproverInfo",
  data() {
    return {
      tableData: [],
      search: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      dialogVisible: false,
      form: { id: null, username: '', name: '', department: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        department: [{ required: true, message: '请选择部门', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      isMobile: window.innerWidth <= 768
    }
  },
  created() {
    this.load();
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    async load() {
      this.loading = true;
      try {
        const res = await request.get('/approver/find/all', {
          params: { pageNum: this.pageNum, pageSize: this.pageSize, search: this.search }
        });
        if (res.code === '0') {
          this.tableData = res.data.records || [];
          this.total = res.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },
    openAdd() {
      this.form = { id: null, username: '', name: '', department: '', password: '' };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.formRef?.clearValidate());
    },
    openEdit(row) {
      this.form = { ...row, password: '' };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.formRef?.clearValidate());
    },
    async handleSave() {
      try {
        await this.$refs.formRef.validate();
      } catch { return; }

      if (this.form.id) {
        // 编辑
        const updateData = { id: this.form.id, name: this.form.name, department: this.form.department };
        if (this.form.password) updateData.password = this.form.password;
        const res = await request.post('/approver/update', updateData);
        if (res.code === '0') {
          ElMessage.success('更新成功');
          this.dialogVisible = false;
          this.load();
        } else {
          ElMessage.error(res.msg || '更新失败');
        }
      } else {
        // 新增
        const res = await request.post('/approver/add', this.form);
        if (res.code === '0') {
          ElMessage.success('添加成功');
          this.dialogVisible = false;
          this.load();
        } else {
          ElMessage.error(res.msg || '添加失败');
        }
      }
    },
    async handleDelete(row) {
      const res = await request.post('/approver/delete', { id: row.id });
      if (res.code === '0') {
        ElMessage.success('删除成功');
        this.load();
      } else {
        ElMessage.error(res.msg || '删除失败');
      }
    },
    deptTagType(dept) {
      const map = { '总务科': '', '学工科': 'warning', '校领导': 'danger' };
      return map[dept] || 'info';
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    }
  }
}
